import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import curved6 from "assets/images/curved-images/curved14.jpg";
import LocationSearch from "./googleInput";
import { motion } from "framer-motion";
import toast from "react-hot-toast";
import { baseURL } from "utils/api";
import "./SignUp.css";
import vector1 from "../../../assets/images/o1.png";
import vector2 from "../../../assets/images/o2.png";
import vector3 from "../../../assets/images/o3.png";
import SelectLocation from "components/location";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";

function SignUp() {

  const userTheme = useSelector((state) => state.commonSlice.theme);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [currentStep, setCurrentStep] = useState(1); // Step state
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchFirst, setSearchFirst] = useState(false);
  const [loading, setLoading] = useState(false);
  const [madeChanges, setMadeChanges] = useState(false);
  const [addressData, setAddressData] = useState('');
  const matches = useMediaQuery("(max-width:600px)");
  const [values, setValues] = useState({
    category: "",
    confirmPassword: "",
    contact_person_name: "",
    email: "",
    first_name: "",
    latitude: 27.964157,
    longitude: -82.452606,
    mobileNumber: "",
    password: "",
    userType: "businessUser",
    zipcode: "",
    countryCode: "+1",
    city: "",
    state: "",
    add_line: "",
    sub_add_line: "",
    country: "",
    zipcode: "",
  });


  useEffect(() => {
    if (addressData) {
      setValues({
        ...values,
        add_line: addressData?.address,
        sub_add_line: addressData?.subAddress,
        city: addressData?.city,
        state: addressData?.state,
        country: addressData?.country,
        zipcode: addressData?.zipcode,
      });
    }
  }, [addressData]);


  useEffect(() => {
    fetch(`${baseURL}/categories`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          const options = data.data.map((elm) => ({
            name: elm.categoryName,
            value: elm._id,
            logo: elm?.categoryLogo,
            image: elm?.categoryImage,
          }));
          setCategories(options);
        }
      });
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true);

    if (!values.first_name.trim()) {
      toast.error("Business Name is required");
      setLoading(false);
      return;
    }
    if (!values.contact_person_name.trim()) {
      toast.error("Contact person Name is required");
      setLoading(false);
      return;
    }
    if (!values.email.trim()) {
      toast.error("Email is required");
      setLoading(false);
      return;
    }
    if (!values.email.includes("@")) {
      toast.error("Email should be valid");
      setLoading(false);
      return;
    }

    if (!values.mobileNumber.trim()) {
      toast.error("Phone Number is required");
      setLoading(false);
      return;
    }
    if (values.mobileNumber.length < 10) {
      toast.error("Phone Number should be 10 digits");
      setLoading(false);
      return;
    }
    if (!values.password.trim()) {
      toast.error("Password is required");
      setLoading(false);
      return;
    }
    if (!values.confirmPassword.trim()) {
      toast.error("Confirm Password is required");
      setLoading(false);
      return;
    }
    if (values.password !== values.confirmPassword) {
      toast.error("Password and Confirm Password do not match. Please try again.");
      setLoading(false);
      return;
    };

    const findCityId = await fetch(`${baseURL}/get-id-for-address`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cityName: values.city,
          stateName: values.state,
          countryName: values.country
        })
      }
    ).then(res => res.json());

    if (findCityId.status === 200) {
      values.city = findCityId.data?.id;
      values.state = findCityId.data?.state?.id;
      values.country = findCityId.data?.country?.id;
    }

    fetch(`${baseURL}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === 200) {
          navigate("/login");
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const validateStep = () => {
    switch (currentStep) {
      case 1:
        if (!values.category) {
          toast.error("Category is required");
          return false;
        }
        break;
      case 2: // Step 3: Password
        if (!values.latitude || !values.longitude) {
          toast.error("Location is required");
          return false;
        }
        break;

      default:
        return true;
    }
    return true;
  };

  const nextStep = () => {
    if (validateStep() && currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };


  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  };

  const handleConfirmPasswordToggle = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleCategorySelect = (category) => {
    setValues({ ...values, category: category?.value });
  };


  const vectorImages = [
    vector3,
    vector2,
    vector1,
  ];

  const stepsContent = [

    {
      heading: "Which category does your business belong to?",
      content: (
        <>
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            my={5}
          >

            <SoftBox display="flex" flexWrap="wrap" alignItems="center" gap={1}>
              {categories.map((category) => (
                <Card
                  onClick={() => handleCategorySelect(category)}
                  style={{ cursor: "pointer", border: values.category == category.value ? "1px solid #fff" : 'none', }}
                  sx={{
                    color: userTheme == 'dark' ? "white" : 'black',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: "10px",
                    background: "rgba(255, 255, 255, 0.1)", /* Transparent white background */
                    backdropFilter: "blur(10px)",
                    borderRadius: "10px",
                    fontSize: "12px",
                    width: "120px",
                    height: "100px",
                    boxShadow: values.category == category.value ? userTheme == "dark" ? "0 0 10px rgba(0,0,0,0.1)" : "0 0 10px rgba(0, 0, 0, 0.49)" : 'none',
                    border: '1px solid #fff',
                  }}
                >
                  <img
                    src={category.logo}
                    alt={category.name}
                    style={{
                      width: "40px",
                      height: "52px",
                      margin: "5px",
                      objectFit: "contain",
                      filter: userTheme == "dark" ? "invert(1)" : "invert(0)", // Invert colors for dark theme
                    }}
                  />

                  <SoftTypography variant="caption" textAlign="center">
                    {category.name}
                  </SoftTypography>

                </Card>
              ))}
            </SoftBox>

          </SoftBox>
        </>
      ),
    },


    {
      heading: "Search your location",
      content: (
        <SoftBox
        // mb={-22}
        // mt={-22}
        // height={250}
        >
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            Search Google Place
          </SoftTypography>
          <LocationSearch setMadeChanges={setMadeChanges} setAddressData={setAddressData} setSearchFirst={setSearchFirst} fetchApi={true} setValues={setValues} />

          <SoftBox
            height={300}
          >
            <SelectLocation
              height="30vh"
              lat={values.latitude}
              lng={values.longitude}
              setValues={setValues}
              fetchApi={false}
              disabled={!searchFirst}
            />
          </SoftBox>

        </SoftBox>
      ),
    },
    {
      heading: "What's your business name?",
      content: (
        <>
          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Business Name *
            </SoftTypography>
            <SoftInput
              required
              placeholder="Business Name"
              name="first_name"
              value={values.first_name}
              onChange={onChange}
            />
          </SoftBox>
          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Contact Person Name *
            </SoftTypography>
            <SoftInput
              required
              placeholder="Enter Name"
              name="contact_person_name"
              value={values.contact_person_name}
              onChange={onChange}
            />
          </SoftBox>

          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email *
            </SoftTypography>
            <SoftInput
              required
              type="email"
              placeholder="Email"
              name="email"
              value={values.email}
              onChange={onChange}
            />
          </SoftBox>

          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Phone Number *
            </SoftTypography>
            <div style={{ display: "flex", gap: "10px" }}>
              <SoftInput
                required
                type="text"
                placeholder="Country Code"
                name="countryCode"
                value={values.countryCode}
                onChange={onChange}
                style={{ maxWidth: "80px" }}
              />
              <SoftInput
                required
                onWheel={(e) => e.target.blur()}
                type="tel"
                placeholder="Phone Number"
                name="mobileNumber"
                value={values.mobileNumber}
                onChange={(e) => {
                  const input = e.target.value;
                  if (/^\d{0,12}$/.test(input)) {
                    onChange(e); // Update value if input is valid
                  }
                }}
                onBlur={(e) => {
                  const input = e.target.value;
                  if (input.length < 8 || input.length > 12) {
                    toast.error("Phone number must be between 8 and 12 digits.");
                  }
                }}
                title="Please enter a valid phone number with 8 to 12 digits."
              />

            </div>
          </SoftBox>
          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password *
            </SoftTypography>
            <div style={{ position: "relative" }}>
              <SoftInput
                required
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={onChange}
              />
              <div
                onClick={handlePasswordToggle}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: userTheme === 'dark' ? 'white' : 'black'
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </div>
            </div>
          </SoftBox>
          <SoftBox>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Confirm Password *
            </SoftTypography>
            <div style={{ position: "relative" }}>
              <SoftInput
                required
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={onChange}
              />
              <div
                onClick={handleConfirmPasswordToggle}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: userTheme === 'dark' ? 'white' : 'black'
                }}
              >
                {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </div>
            </div>
          </SoftBox>
        </>
      ),
    },
  ];

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (currentStep < 5) nextStep();
    }
  };

  return (
    <BasicLayout
      title="Welcome!"
      description="Use these awesome forms to login or create new account in your project for free."
      image={curved6}
      currentStep={currentStep}
    >
      <SoftBox m={1} className="signup-container">
        {/* Left Section: Form */}
        <Card sx={{ marginTop: "40px" }} className="form-card glassmorphism-card" onKeyDown={handleKeyDown} tabIndex={0}>
          {/* <form onSubmit={handleSubmit}> */}
          <SoftBox p={2} textAlign="center">
            <SoftTypography variant="h6" fontWeight="medium" mt={1}>
              {stepsContent[currentStep - 1].heading}
            </SoftTypography>
          </SoftBox>
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5 }}
          >
            <SoftBox px={3} pb={3}>
              {stepsContent[currentStep - 1].content}
            </SoftBox>
          </motion.div>
          <SoftBox
            px={3}
            // mt={currentStep==3?20:0}
            // py={20}
            mb={2}
            gap={2}
            display="flex"
            justifyContent={currentStep > 1 ? "space-between" : "flex-end"}
          >
            {currentStep > 1 && (
              <SoftButton
                fullWidth
                variant="outlined"
                color="info"
                onClick={prevStep}
              >
                Back
              </SoftButton>
            )}
            {currentStep < 3 ? (
              <SoftButton
                fullWidth
                variant="gradient"
                color={!madeChanges && currentStep == 2 ? "light" : 'info'}
                disabled={!madeChanges && currentStep == 2}
                onClick={nextStep}
              >
                Next
              </SoftButton>
            ) : (
              <SoftButton
                fullWidth
                variant="gradient"
                // type="submit"
                color={values.first_name.trim() === "" || values.email.trim() === "" || values.mobileNumber.trim() === "" || values.password.trim() === "" || values.confirmPassword.trim() === "" ? "light" : 'info'}
                disabled={values.first_name.trim() === "" || values.email.trim() === "" || values.mobileNumber.trim() === "" || values.password.trim() === "" || values.confirmPassword.trim() === ""}

                onClick={handleSubmit}
              >
                {loading ? "Loading..." : "Sign Up"}
              </SoftButton>
            )}
          </SoftBox>
          {/* </form> */}
        </Card>

        {/* Right Section: Image */}
        <div className="vector-container">
          <motion.img
            key={currentStep}
            src={vectorImages[currentStep - 1]}
            alt={`Step ${currentStep} Vector`}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            className="vector-image"
          />
           <SoftBox mt={3} textAlign="center" >
            <SoftTypography variant="button" display="flex" color="text" fontWeight="regular">
              Already have an account?{" "}
              <SoftTypography
                component={Link}
                to="/login"
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                {" "} Sign in
              </SoftTypography>
            </SoftTypography>
          </SoftBox>
        </div>
      </SoftBox>
    </BasicLayout>
  );
}

export default SignUp;
